<template>
	<div class="redy91dd">
		<!-- tab -->
		<div
			v-for="(item, i) in tabs"
			:key="i"
			:style="'width: ' + 100 / tabs.length + '%'"
			class="tab"
			:class="[{ 'tab--selected': item.value === selectedTab }]"
			@click="$emit('click', item.value)"
		>
			{{ item.name }}
		</div>
	</div>
</template>

<script>
export default {
	name: "j-tabs",
	props: {
		tabs: {
			/**
			 * [{ name: "all", value: "I am first tab"}]
			 */
			type: Array,
			required: true,
			default: []
		},
		selectedTab: {
			type: String,
			required: false
		}
	}
}
</script>

<style scoped>
@import "../../assets/css/tokens.css";

.redy91dd {
	display: flex;
	justify-content: space-between;
	background-color: var(--color0);
	width: 100%;
	border-top-left-radius: var(--borderRadius2);
	border-top-right-radius: var(--borderRadius2);
	overflow-y: hidden;
	overflow-x: auto;
	-webkit-overflow-scrolling: touch;
	user-select: none;
}

.redy91dd::-webkit-scrollbar {
	display: none;
	height: 0;
	opacity: 0;
}

.tab {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 48px;
	padding: 0 var(--spacing2);
	background-color: var(--color0);
	border: 1px solid var(--color7);
	border-bottom: 0;
	border-left: 0;
	border-top-left-radius: var(--borderRadius2);
	border-top-right-radius: var(--borderRadius2);
	color: var(--color7-dark-2);
	font-size: var(--fontSize3);
	line-height: var(--lineHeight125);
	font-weight: var(--fontWeight7);
	text-align: center;
	cursor: pointer;
}

.tab:hover {
	background-color: var(--color4);
}

.tab:first-child {
	border-left: 1px solid var(--color7);
}

.tab.tab--selected {
	opacity: 1;
	color: var(--color1);
	background-color: var(--color5);
}
</style>
